import { Card } from '@/components/ui/card';
import { formatPercentage } from '@/utils/helpers';

export interface InterestRateTypeCardProps {
  floatingPct: number; // as percentage number, e.g., 15 for 15%
  fixedPct: number; // as percentage number
}

export function InterestRateTypeCard(props: InterestRateTypeCardProps) {
  const { floatingPct, fixedPct } = props;

  return (
    <Card className="p-6" data-test-id="interest-rate-type-card">
      <h3
        className="text-lg font-semibold text-gray-900 mb-4"
        data-test-id="interest-rate-type-title"
      >
        Interest Rate Type
      </h3>
      <div
        className="grid grid-cols-2 gap-4"
        data-test-id="interest-rate-type-grid"
      >
        <div
          className="flex items-center justify-between p-4 bg-blue-50 rounded-lg"
          data-test-id="floating-rate-box"
        >
          <div>
            <p
              className="text-sm font-medium text-gray-700"
              data-test-id="floating-label"
            >
              Floating
            </p>
            <p
              className="text-2xl font-bold text-blue-600"
              data-test-id="floating-percentage"
            >
              {formatPercentage(floatingPct, 1)}
            </p>
          </div>
        </div>
        <div
          className="flex items-center justify-between p-4 bg-green-50 rounded-lg"
          data-test-id="fixed-rate-box"
        >
          <div>
            <p
              className="text-sm font-medium text-gray-700"
              data-test-id="fixed-label"
            >
              Fixed
            </p>
            <p
              className="text-2xl font-bold text-green-600"
              data-test-id="fixed-percentage"
            >
              {formatPercentage(fixedPct, 1)}
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
}
